import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
// because Union date picker sends dates in UTC
// so only care about the UTC date
export var utcDateToString = function utcDateToString(dateString) {
  var _Date$toISOString$spl = new Date(dateString).toISOString().split('T'),
    _Date$toISOString$spl2 = _slicedToArray(_Date$toISOString$spl, 1),
    date = _Date$toISOString$spl2[0];
  return date;
};